import * as React from 'react';
import { navigate } from 'router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import OrgUserList from '~/apps/shared/containers/users/OrgUserList';


export default function () {
  return (
    <CurrentOrgInjector
      component={OrgUserList}
      onEdit={(userId) => navigate('sender.settings.team.edit', { userId })}
    />
  );
}
